export default "__VITE_ASSET__iPA_7961__"